// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductionOperators_PerformanceInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /so/production_operators/performance
 *
 * Validates optional date range query parameters.
 */
import { registerContract } from './validate'

export interface ProductionOperators_PerformanceInput {
date_from?: string
date_to?: string
}

registerContract('ProductionOperators_PerformanceInput', {
  date_from: { type: 'string',  required: false },
  date_to:   { type: 'string',  required: false },
})
